"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var container = {
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    backgroundColor: 'transparent',
};
exports.default = {
    container: container,
};
//# sourceMappingURL=image-zoom.style.js.map